<div class="modal-header">
  <h4 class="modal-title pull-left">Update Report Delay</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <ng-container *ngIf="isStart === true">
    <div class="row">
      <div class="col-sm-12">
        <label class="rbv-label">
          Delay Notes for Client Link
          <small>  (visible to client)</small>
        </label>

        <div class="area-wrapper">
          <textarea class="form-control rounded-0" rows="3" name="NOTES" [(ngModel)]="delay.NOTE_START"></textarea>

          <div class="canned-actions">
            <div class="c-action email" (click)="appendCannedAction('NOTE_START', 'delayed')">delayed</div>
            <div class="c-action phone" (click)="appendCannedAction('NOTE_START','no response')">no response</div>
            <div class="c-action email" (click)="appendCannedAction('NOTE_START','real est')">real est</div>
            <div class="c-action vmail" (click)="appendCannedAction('NOTE_START','equip appr')">equip appr</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label class="rbv-label">
          Reason
          <small>  (not visible to client)</small>
          <small>  (optional)</small>
        </label>

        <div class="area-wrapper">
          <textarea class="form-control rounded-0" rows="3" name="REASON" [(ngModel)]="delay.REASON_START"></textarea>

          <div class="canned-actions">
            <div class="c-action email" (click)="appendCannedAction('REASON_START', 'delayed')">delayed</div>
            <div class="c-action phone" (click)="appendCannedAction('REASON_START','no response')">no response</div>
            <div class="c-action email" (click)="appendCannedAction('REASON_START','real est')">real est</div>
            <div class="c-action vmail" (click)="appendCannedAction('REASON_START','equip appr')">equip appr</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>


  <ng-container *ngIf="isStart !== true">
    <div class="row">
      <div class="col-sm-12">
        <label class="rbv-label">
          Delay Notes for Client Link
          <small>  (visible to client)</small>
        </label>

        <div class="area-wrapper">
          <textarea class="form-control rounded-0" rows="3" name="NOTES" [(ngModel)]="delay.NOTE_END"></textarea>

          <div class="canned-actions">
            <div class="c-action email" (click)="appendCannedAction('NOTE_END', 'delayed')">delayed</div>
            <div class="c-action phone" (click)="appendCannedAction('NOTE_END','no response')">no response</div>
            <div class="c-action email" (click)="appendCannedAction('NOTE_END','real est')">real est</div>
            <div class="c-action vmail" (click)="appendCannedAction('NOTE_END','equip appr')">equip appr</div>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label class="rbv-label">
          Reason
          <small>  (not visible to client)</small>
          <small>  (optional)</small>
        </label>

        <div class="area-wrapper">
          <textarea class="form-control rounded-0" rows="3" name="REASON" [(ngModel)]="delay.REASON_END"></textarea>

          <div class="canned-actions">
            <div class="c-action email" (click)="appendCannedAction('REASON_END', 'delayed')">delayed</div>
            <div class="c-action phone" (click)="appendCannedAction('REASON_END','no response')">no response</div>
            <div class="c-action email" (click)="appendCannedAction('REASON_END','real est')">real est</div>
            <div class="c-action vmail" (click)="appendCannedAction('REASON_END','equip appr')">equip appr</div>
          </div>
        </div>

      </div>
    </div>
  </ng-container>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Update</button>
</div>
